var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_43709)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_653_43709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.334,
    cy: 29,
    r: 29,
    fill: "#E8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.002 29.001C18.002 34.029 18.002 39.211 19.759 40.771C21.517 42.334 24.346 42.334 30.002 42.334C35.658 42.334 38.487 42.334 40.245 40.772C42.002 39.209 42.002 34.029 42.002 29.001",
    stroke: "#0069FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5509 31.936L41.5609 29.534C42.3549 29.295 42.7519 29.176 43.0039 28.891C43.0539 28.835 43.0986 28.7753 43.1379 28.712C43.3379 28.388 43.3379 27.975 43.3379 27.146C43.3379 23.879 43.3379 22.246 42.4399 21.143C42.2676 20.9307 42.0739 20.7367 41.8619 20.564C40.7589 19.667 39.1259 19.667 35.8589 19.667H24.1509C20.8839 19.667 19.2509 19.667 18.1479 20.564C17.936 20.7367 17.7423 20.9307 17.5699 21.143C16.6699 22.246 16.6699 23.879 16.6699 27.146C16.6699 27.975 16.6699 28.388 16.8699 28.712C16.9099 28.7747 16.9546 28.8343 17.0039 28.891C17.2579 29.176 17.6539 29.295 18.4469 29.534L26.4569 31.936M22.6719 19.667C23.7689 19.64 24.8849 18.94 25.2589 17.907L25.3049 17.77L25.3389 17.667C25.3949 17.497 25.4239 17.414 25.4529 17.339C25.6416 16.8708 25.9591 16.4657 26.3687 16.1707C26.7783 15.8756 27.2631 15.7027 27.7669 15.672C27.8449 15.667 27.9359 15.667 28.1119 15.667H31.8959C32.0729 15.667 32.1629 15.667 32.2429 15.672C32.7465 15.7032 33.231 15.8764 33.6402 16.1716C34.0494 16.4668 34.3665 16.8719 34.5549 17.34C34.5849 17.415 34.6139 17.5 34.6699 17.668L34.7039 17.771C34.7279 17.841 34.7389 17.877 34.7509 17.908C35.1239 18.941 36.2389 19.641 37.3359 19.668",
    stroke: "#0069FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6699 29.667H27.3369C27.2493 29.6669 27.1625 29.684 27.0815 29.7175C27.0005 29.751 26.927 29.8001 26.865 29.8621C26.803 29.924 26.7539 29.9976 26.7204 30.0786C26.687 30.1596 26.6698 30.2464 26.6699 30.334V33.216C26.6704 33.3491 26.7105 33.4791 26.7851 33.5894C26.8597 33.6996 26.9655 33.7851 27.0889 33.835L28.0219 34.208C29.2938 34.7173 30.713 34.7173 31.9849 34.208L32.9179 33.835C33.0414 33.7851 33.1471 33.6996 33.2218 33.5894C33.2964 33.4791 33.3365 33.3491 33.3369 33.216V30.334C33.3371 30.2464 33.3199 30.1596 33.2864 30.0786C33.2529 29.9976 33.2038 29.924 33.1419 29.8621C33.0799 29.8001 33.0063 29.751 32.9253 29.7175C32.8443 29.684 32.7576 29.6669 32.6699 29.667Z",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_43709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.333984)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_653_43709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.7680977bcadadafaf42b34013303782d.svg";
export { ForwardRef as ReactComponent };